module.exports = __webpack_public_path__ + "img/drop.aa2f5857.svg";